import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getBusinessId } from '../../lib/Api';
import { useUserInfoQuery } from '../../lib/Queries';
import { useEffect } from 'react';
import { getLastBusinessId } from '../../lib/BusinessHelpers.js';

const RedirectCurrentPage = ({}) => {
    const { data } = useUserInfoQuery();
    const { pathname, search } = useLocation();
    const currentBusinessId = getBusinessId() || getLastBusinessId();
    const navigate = useNavigate();

    function redirect(businessId) {
        if (!businessId) {
            return;
        }

        const newPath = pathname.replace(
            '/current/',
            `/business/${businessId}/`,
        );
        navigate(`${newPath}${search}`);
    }

    useEffect(() => {
        if (currentBusinessId) {
            redirect(currentBusinessId);
        } else if (data?.businesses?.length) {
            redirect(data?.businesses[0]?.id);
        } else if (Array.isArray(data?.businesses) && !data.businesses.length) {
            // No businesses
            navigate('/');
        }
    }, [JSON.stringify(data?.businesses), currentBusinessId]);

    return (
        <div>
            <Link to="/">Go to business list</Link>
        </div>
    );
};

export default RedirectCurrentPage;
